import { render, staticRenderFns } from "./OverseaServiceInfo.vue?vue&type=template&id=00baa70d&scoped=true"
import script from "./OverseaServiceInfo.vue?vue&type=script&lang=js"
export * from "./OverseaServiceInfo.vue?vue&type=script&lang=js"
import style0 from "./OverseaServiceInfo.vue?vue&type=style&index=0&id=00baa70d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00baa70d",
  null
  
)

export default component.exports